import WebsiteBehaviors from "../website-behaviors/index.js";

class FrontiersIn extends WebsiteBehaviors {
	identifier() {
		return "FrontiersIn";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return location.host === "www.frontiersin.org";
	}

	styles() {
		// language=CSS
		return `
			body {
				height: auto !important;
			}
		`;
	}
}

export default FrontiersIn;
